import useAxios from "./use-axios";

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useCreateUser = () =>
  useAxios(
    {
      url: `/user`,
      method: "POST",
    },
    { manual: true }
  );

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useUser = (userId) =>
  useAxios({
    url: `/user/${userId}`,
  });

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useUsers = (limit, offset) =>
  useAxios({
    url: `/user`,
    params: { limit, offset },
  });

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useUpdateUser = (userId) =>
  useAxios(
    {
      url: `/user/${userId}`,
      method: "PUT",
    },
    { manual: true }
  );

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const usePatchUser = (userId) =>
  useAxios(
    {
      url: `/user/${userId}`,
      method: "PATCH",
    },
    { manual: true }
  );

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useChangePasswordUser = (userId) =>
  useAxios(
    {
      url: `/user/${userId}/password`,
      method: "PUT",
    },
    { manual: true }
  );

/**
 * Deprecated -> migrate to tanstack/react-query
 */
export const useDeleteUser = (id) => {
  return useAxios(
    {
      url: `/user/${id}`,
      method: "DELETE",
    },
    { manual: true }
  );
};
